export default __webpack_public_path__ + "static/media/email.aee5f2f3.png";